import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modale-errore-generico',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="modal-card" (click)="activeModal.dismiss()">
      <div class="modal-icon modal-icon-error">
        <i class="bi bi-x-lg"></i>
      </div>
      <div class="modal-title">{{ title || 'Errore' }}</div>
      <div class="modal-subtitle">{{ message || 'Si è verificato un errore imprevisto.' }}</div>
    </div>
  `
})
export class ModaleErroreGenericoComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  @Input() title = '';
  @Input() message = '';

  ngOnInit() {
    setTimeout(() => {
      this.activeModal.dismiss();
    }, 2000);
  }
}
